export default __webpack_public_path__ + "static/media/question.3e26dc8f.gif";